import archive from './archive';
import frontPage from './front-page';
import page from './page';
import single from './single';

const modules = {
  archive,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'front-page': frontPage,
  page,
  single,
};

export default modules;
